import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import back from "../../assets/back.svg";
import VersionHistoryBtn, {
  AdminButton,
} from "../../components/buttons/versionHistoryBtn";
import DeleteModal from "../../components/modals/deleteModal";
import DeletedPopUp from "../../components/popups/DeletedPopUp";
import {
  deleteSuperUser,
  superUserDetails,
} from "../../redux/actions/superUserAction";
import ErrorPopup from "../../components/popups/ErrorPopup";
import LoadingSpinnerTable from "../../components/utilites/loader";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";

const SuperUserDetail = () => {
  const navigate = useNavigate();
  const params = useParams();
  const dispatch = useDispatch();
  const [superUserData, setSuperUserData] = useState(null);
  const [deleteShow, setDeleteShow] = useState(false);
  const [deletedPop, setDeletedPop] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    console.log(params?.id);
    dispatch(superUserDetails(params?.id, onSuccess, onError));
  }, []);

  const onSuccess = (data) => {
    setLoading(false);
    setSuperUserData(data.data.data);
  };
  const onError = (err) => {
    setLoading(false);
    console.log(err);
  };

  const deleteFn = () => {
    dispatch(
      deleteSuperUser(superUserData?.id, onDeleteSuccess, onDeleteError)
    );
  };

  const onDeleteSuccess = (data) => {
    console.log(data);
    setDeletedPop(true);

    const timeOutFnc = () => {
      setDeletedPop(false);
      navigate("/super-user/user");
    };

    setTimeout(timeOutFnc, 2000);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onDeleteError = (err) => {
    console.log(err);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };
  const routes = [
    { path: "/", breadcrumb: "Admin" },
    {
      path: "/super-user/user",
      breadcrumb: " / super users",
    },

    {
      path: "/super-user/user/view/:id",
      breadcrumb: superUserData?.employee_id
        ? ` / ${superUserData?.employee_id} - view`
        : " / view",
    },
  ];
  const breadcrumbs = useReactRouterBreadcrumbs(routes, {
    disableDefaults: true,
  });

  return (
    <>
      <div className="products-page">
        <div className="products-main-div">
          <div className="mx-3">
            {breadcrumbs.map(({ match, breadcrumb }) => (
              <NavLink
                key={match.pathname}
                to={match.pathname}
                className="header-route-page fw_400 cursor_pointer"
              >
                <span className="fs_18">{breadcrumb}</span>
              </NavLink>
            ))}
          </div>
          <div className="products-main-list my-2 py-1">
            <div className="search-container d-flex justify-content-between align-items-center">
              <div
                className="d-flex align-items-center p-2 ms-3 m-1 mb-2 cursor_pointer"
                onClick={() => navigate(-1)}
              >
                <img src={back} alt="back_btn" />
                <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
                  BACK
                </span>
              </div>
              <div className=" d-flex justify-content-between m-1 mb-2">
                <VersionHistoryBtn
                  link={`/super-user/user/version-history-detail/${params?.id}`}
                />
                <AdminButton
                  background="#7065E4"
                  color="white"
                  width="100px"
                  onClick={() =>
                    navigate(`/super-user/user/edit/${params?.id}`)
                  }
                >
                  <span className="m-2">EDIT</span>
                </AdminButton>
                <AdminButton
                  background="#FF6F5B"
                  color="white"
                  width="100px"
                  onClick={() => setDeleteShow(true)}
                >
                  <span className="m-2">DELETE</span>
                </AdminButton>
              </div>
            </div>
            <div style={{ position: "relative" }}>
              {loading == true ? (
                <div className="list-spinner-container">
                  <LoadingSpinnerTable />
                </div>
              ) : (
                <div className="  ps-4 ps-lg-4 ms-3 mt-4 col-lg-5 col-md-6 col-10 ">
                  <div className="my-4">
                    <label className=" Neutral_Color fs_14">
                      Company Employee ID
                    </label>
                    <p className="fs_14">
                      {superUserData?.employee_id
                        ? superUserData?.employee_id.charAt(0).toUpperCase() +
                          superUserData?.employee_id.slice(1)
                        : "--"}
                    </p>
                  </div>
                  <div className="my-4">
                    <label className=" Neutral_Color fs_14">Name</label>
                    <p className="fs_14">
                      {superUserData?.name
                        ? superUserData?.name.charAt(0).toUpperCase() +
                          superUserData?.name.slice(1)
                        : "--"}
                    </p>
                  </div>
                  <div className="my-4">
                    <label className=" Neutral_Color fs_14 text-capitalize">
                      Role
                    </label>
                    <p className="fs_14">
                      {superUserData?.vendorRoleModule?.role_name
                        ? superUserData?.vendorRoleModule?.role_name
                        : "--"}
                    </p>
                  </div>
                  <div className="my-4">
                    <label className=" Neutral_Color fs_14">
                      Email Address
                    </label>
                    <p className="fs_14">{superUserData?.email}</p>
                  </div>
                  <div className="my-4">
                    <label className=" Neutral_Color fs_14">Phone Number</label>
                    <p className="fs_14">+91 {superUserData?.mobile}</p>
                  </div>
                  {/* <div className="my-4">
              <label className=" Neutral_Color fs_14">Phone Number</label>
              <p className="fs_14">+91{superUserData?.alternate_mobile}</p>
            </div> */}
                  <div className="my-4">
                    <label className=" Neutral_Color fs_14">Division</label>
                    <p className="fs_14">
                      {superUserData?.superUserDivisions?.map((ele, index) => {
                        return (
                          <span key={index}>
                            {index ? (
                              <span className="mx-1 color_b0b3c7">|</span>
                            ) : (
                              ""
                            )}
                            {ele?.vendorDivision?.name}
                          </span>
                        );
                      })}
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <DeleteModal
          title={`this Super User - ${superUserData?.employee_id}`}
          show={deleteShow}
          handleClose={() => setDeleteShow(false)}
          delFunc={deleteFn}
        />
        <DeletedPopUp
          title={`Super User - ${superUserData?.employee_id}`}
          show={deletedPop}
        />
        <ErrorPopup
          show={showErrorPopup}
          title={showErrorMsg}
          handleClose={closeErrorPopup}
        />
      </div>
    </>
  );
};

export default SuperUserDetail;
